<template>
    <div class="subscribe">
        
        <div class="box gzh" v-show="osType == 'wx'">
            <h2>微信公众号关注流程</h2>
            <p>1.打开微信app,点击右上角搜索按钮</p>
            <img src="../../../static/images/gzh1.jpg" alt="关注微信公众号引导图">
            <p>2.点击搜索按钮以后进入搜索页面,输入城际停车服务</p>
            <img src="../../../static/images/gzh2.jpg" alt="关注微信公众号引导图">
            <p>2.点击搜索结果列表里面的城际停车服务公众号</p>
            <img src="../../../static/images/gzh3.jpg" alt="关注微信公众号引导图">
            <p>2.进入城际停车服务公众号页面,点击关注公众号即可完成</p>
            <img src="../../../static/images/gzh4.jpg" alt="关注微信公众号引导图">
        </div>
        <div class="box shh" v-show="osType == 'al'">
            <h2>支付宝生活号关注流程</h2>
            <p>1.打开支付宝app,点击点击搜索框右边的通讯录按钮</p>
            <img src="../../../static/images/shh1.jpg" alt="关注支付宝生活号引导图">
            <p>2.进入通讯录页面,点击生活号</p>
            <img src="../../../static/images/shh2.jpg" alt="关注支付宝生活号引导图">
            <p>2.进入生活号,点击顶部导航右边的搜索按钮</p>
            <img src="../../../static/images/shh3.jpg" alt="关注支付宝生活号引导图">
            <p>2.进入生活号搜索页面,输入城际停车服务,点击搜索,在搜索结果中点击spps城际停车服务</p>
            <img src="../../../static/images/shh4.jpg" alt="关注支付宝生活号引导图">
            <p>2.进入城际停车服务生活号主页面,点击关注生活号即可完成关注</p>
            <img src="../../../static/images/shh5.jpg" alt="关注支付宝生活号引导图">
        </div>
        <div class="box shh" v-show="osType == 'other'">
            <h2>请用支付宝或者微信打开此页面</h2>
        </div>
        <div class="backToTop" v-show="showBackToTop" @click="backToTop"></div>
    </div>
</template>
<script>
  export default {
    name:"subscribe",
    data() {
      return {
          osType: '',
          title: '关注流程',
          showBackToTop: false
      }
    },
    methods:{
        backToTop(){
            clearInterval(Timer)
            let st = document.body.scrollTop
            let Timer = setInterval(()=>{
                let newSt = st>50?st-50:0
                document.body.scrollTop = newSt
                document.documentElement.scrollTop = newSt
                window.pageXOffset = newSt
                st = newSt
                st == 0 && clearInterval(Timer)
            },10)
            
        },
        listenScroll(){
            const self = this
            let st = document.body.scrollTop
            let pageY = document.body.offsetHeight || document.documentElement.scrollTop || window.pageXOffset
            self.showBackToTop = st>document.body.offsetHeight? true: false
        }
    },
    created(){
        // this.osType = 'wx'
        this.osType = this.commonUtil.browserType()
        this.listenScroll()
        window.addEventListener("scroll", this.listenScroll, true) //vue 设置为true 才可以监听这个事件了
    },
    computed(){

    },
    mounted() {
        
    }
  };
</script>
<style scoped>
    h2{
        font-size: 20px;
        line-height: 40px;
        font-weight: bold;
    }
    .box{
        width: 92%;
        margin: 0 auto;
    }
    p{
        text-align: left;
        font-size: 15px;
        line-height: 20px;
        margin-bottom: 8px;
        color: #4f4f4f;
        font-weight: bold;
    }
    img{
        display: block;
        width: 90%;
        margin: 0 auto;
        margin-bottom: 15px;
        box-shadow: 0 0 3px #ccc;
    }
    .backToTop{
        width: 30px;
        height: 30px;
        position: fixed;
        right: 20px;
        bottom: 20px;
        background-image: url('../../../static/images/top.png');
        background-size: 100%;
    }
    .subscribe{
        /* padding-top: 46px; */
        height: 100%;
    }
    .subscribe_tt{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
    }
    .pagecont{
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        padding-top: 46px;
    }
    .pagecontWrap{
        height: 100%;
        overflow: auto;
    }
</style>





// WEBPACK FOOTER //
// src/components/index/subscribe.vue